module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cjwt"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('List', {
    attrs: {
      "list": _vm.list,
      "name": "cjwt"
    }
  }), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("常见问题")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12acc045"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/cjwt/cjwt.vue
// module id = 865
// module chunks = 2